import { Component, inject } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AuthStore } from '../../store/auth.store';
import { TRANSLOCO_SCOPE } from '../../constants/i18n.constants';
import { TranslocoDirective } from '@jsverse/transloco';
import { provideAuthTranslocoScope } from '../../providers/i18n.providers';

@Component({
  imports: [NzButtonModule, TranslocoDirective],
  selector: 'auth-logout-button',
  templateUrl: 'logout-button.component.html',
  providers: [provideAuthTranslocoScope()],
})

export class LogoutButtonComponent {
  private authStore = inject(AuthStore)
  protected readonly translocoPrefix = TRANSLOCO_SCOPE

  handleLogout(): void {
    this.authStore.logout();
  }
}
